(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/hooks/pix-fulltraff.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/hooks/pix-fulltraff.js');
"use strict";


const logger = new svs.core.log.Logger('svs.sport.QuickplayModal');
const {
  convertFulltraffPixEventsToSigns,
  convertFulltraffPixEventsToWagerBoard
} = svs.components.sport.tipsenShared.transformSigns;

async function queryFulltraffPixAsync(_ref) {
  let {
    drawNumber,
    systemCost
  } = _ref;
  const {
    response
  } = await svs.core.jupiter.callAsync({
    method: 'POST',
    path: "/wager/1/fulltraff/pix?drawNumber=".concat(drawNumber, "&flavour=SafeFulltraff&systemType=MSys&systemNumberMapping=").concat(systemCost)
  });
  if (response.error || !response.pix) {
    var _response$error;
    throw new Error(((_response$error = response.error) === null || _response$error === void 0 ? void 0 : _response$error.message) || 'Failed to query wager-API');
  }
  return response.pix;
}

function normaliseFulltraffPix(_ref2) {
  let {
    data,
    productId,
    drawNumber,
    systemCost,
    systemType
  } = _ref2;
  const {
    events
  } = data || {};
  if (!Array.isArray(events) || events.length === 0) {
    throw new Error('Missing "pix.events" in response from wager-API.');
  }
  if (events.some((item, index) => item.eventNumber !== index + 1)) {
    logger.info('Warning: Unexpected use of "eventNumber" inside pix.events delivered by wager-API. This might lead to wrong behavior.');
  }
  return {
    productId,
    drawNumber,
    systemCost,
    signsByEventForOutput: {
      fulltraff: convertFulltraffPixEventsToSigns(events)
    },
    wagerBoardData: {
      fulltraff: convertFulltraffPixEventsToWagerBoard(events)
    },
    systemType
  };
}

setGlobal('svs.components.sport.quickplayModal.hooks', {
  queryFulltraffPixAsync,
  normaliseFulltraffPix
});

 })(window);